export { default } from './Page404';
export { default as template } from './page-404.tpl';
